import { lazy } from 'react';
import { getLocalisedPaths } from '@client/routes/utils/paths';
import { PERMISSION } from 'b2b-common/core/context/Context.types';
import { AUTHENTICATED_ROUTE } from '../constants';
import { AccessCallbackDataType, RouteType } from '../types';

export enum TURNOVER_STATISTICS_ROUTES_NAMES {
  myAccountTurnoverStatistics = 'myAccountTurnoverStatistics',
  myAccountTurnoverStatisticsManufacturer = 'myAccountTurnoverStatisticsManufacturer',
  myAccountTurnoverStatisticsCategory = 'myAccountTurnoverStatisticsCategory',
}

export type TurnoverStatisticsRouteType = Record<TURNOVER_STATISTICS_ROUTES_NAMES, RouteType>;

export const turnoverStatistics: TurnoverStatisticsRouteType = {
  [TURNOVER_STATISTICS_ROUTES_NAMES.myAccountTurnoverStatistics]: {
    ...AUTHENTICATED_ROUTE,
    exact: true,
    paths: getLocalisedPaths('my-account/turnover-statistics'),
    component: lazy(() => import(
      /* webpackChunkName: "my-account/turnover-statistics" */
      'b2b-apps/core/myAccount/turnoverStatistics/components/DashboardPage'
    )),
    allow: ({ isLoggedIn, permissionsValidator }: AccessCallbackDataType) => isLoggedIn
    && permissionsValidator([PERMISSION.accessMyAccountTurnoverStatistics]),
  },
  [TURNOVER_STATISTICS_ROUTES_NAMES.myAccountTurnoverStatisticsManufacturer]: {
    ...AUTHENTICATED_ROUTE,
    exact: true,
    paths: getLocalisedPaths('my-account/turnover-statistics/manufacturer'),
    component: lazy(() => import(
      /* webpackChunkName: "my-account/turnover-statistics-manufacturer" */
      'b2b-apps/core/myAccount/turnoverStatistics/components/DetailsPage'
    )),
    allow: ({ isLoggedIn, permissionsValidator }: AccessCallbackDataType) => isLoggedIn
    && permissionsValidator([PERMISSION.accessMyAccountTurnoverStatistics]),
  },
  [TURNOVER_STATISTICS_ROUTES_NAMES.myAccountTurnoverStatisticsCategory]: {
    ...AUTHENTICATED_ROUTE,
    exact: true,
    paths: getLocalisedPaths('my-account/turnover-statistics/category'),
    component: lazy(() => import(
      /* webpackChunkName: "my-account/turnover-statistics-category" */
      'b2b-apps/core/myAccount/turnoverStatistics/components/DetailsPage'
    )),
    allow: ({ isLoggedIn, permissionsValidator }: AccessCallbackDataType) => isLoggedIn
    && permissionsValidator([PERMISSION.accessMyAccountTurnoverStatistics]),
  },
};
